import { useTheme } from '@/context/ThemeContext';
import { Moon, Sun, Sparkles, Terminal } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme, mode } = useTheme();
  const isExec = mode === 'executive';

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={`w-9 h-9 ${isExec ? 'rounded-xl' : 'rounded-sm'} ${className}`}
      data-testid="theme-toggle"
    >
      {theme === 'dark' ? (
        <Sun className={`w-4 h-4 transition-all ${
          isExec
            ? 'text-amber-400'
            : 'text-yellow-400 drop-shadow-[0_0_8px_rgba(250,204,21,0.7)]'
        }`} />
      ) : (
        <Moon className={`w-4 h-4 transition-all ${
          isExec
            ? 'text-slate-500'
            : 'text-slate-700'
        }`} />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};

export const ModeToggle = ({ className = '', compact = false }) => {
  const { mode, toggleMode } = useTheme();

  if (compact) {
    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleMode}
        className={`rounded-full w-9 h-9 ${className}`}
        data-testid="mode-toggle"
        title={mode === 'operative' ? 'Switch to Executive Mode' : 'Switch to Operative Mode'}
      >
        {mode === 'operative' ? (
          <Sparkles className="w-4 h-4 text-sky-500 transition-all" />
        ) : (
          <Terminal className="w-4 h-4 text-emerald-600 transition-all" />
        )}
      </Button>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="mode-toggle-full">
      <button
        onClick={() => mode !== 'operative' && toggleMode()}
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
          mode === 'operative'
            ? 'bg-emerald-500 text-black shadow-lg shadow-emerald-500/30'
            : 'bg-secondary text-muted-foreground hover:text-foreground'
        }`}
        data-testid="mode-operative-btn"
      >
        <Terminal className="w-3.5 h-3.5 inline mr-1.5" />
        Operative
      </button>
      <button
        onClick={() => mode !== 'executive' && toggleMode()}
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
          mode === 'executive'
            ? 'bg-sky-500 text-white shadow-lg shadow-sky-500/30'
            : 'bg-secondary text-muted-foreground hover:text-foreground'
        }`}
        data-testid="mode-executive-btn"
      >
        <Sparkles className="w-3.5 h-3.5 inline mr-1.5" />
        Executive
      </button>
    </div>
  );
};

export default ThemeToggle;
